module.exports = __webpack_public_path__ + "img/5.bef90e62.jpg";